export default "__VITE_ASSET__B8zoyu6I__"